import React, {Component} from "react";
import * as R from "ramda";
import FlexView from "react-flexview";
import {configMonthToDate, monthOptions, transformResponseMTD, yearOptions} from "../config";
import {removeNullFields} from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";


class MonthToDateSalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: null,
            year: null,
            tableConfig: [],
            dataTable1: [],
            dataTable2: [],
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            // month: monthOptions.find(item => item.value === currentDate.getMonth()),
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            tableConfig: configMonthToDate,
        }));
    };

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (!R.equals(prevProps.search, this.props.search)) {
    //         this.handleSearch();
    //     }
    // };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async (isMergeLeasing) => {
        try {
            this.props.triggerLoading();
            let dataKodeCabang = this.props.search;
            if (this.props.isAllSelected) {
              dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
            }
            const res = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanMTD,
              setError: this.props.setError,
              menuName:
                "Dashboard Level Kepala Cabang Keatas - Laporan Penjualan MTD",
              args: {
                kodeCabang: dataKodeCabang,
                year: this.state.year?.value,
                month: this.state.month?.value,
                mergerLeasing: isMergeLeasing,
                employeeIdTeamLeader: this.props.idLeader,
              },
            });

            if(res.ok && res.data.status === HttpStatus.SUCCESS){
              if (!isMergeLeasing) {
                this.setState((prevValue) => ({
                  ...prevValue,
                  dataTable1: transformResponseMTD(res.data.data),
                }));
              }else{
                this.setState((prevValue) => ({
                  ...prevValue,
                  dataTable2: transformResponseMTD(res.data.data),
                }));
              }
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();

        }
    };

    handleSearch = ()=>{
        this.fetchData();
        this.fetchData(true);
    }

    render() {
        console.log("Search", this.props.search);
        return (
          <>
            <FlexView style={{ gap: "20px", alignItems: "center" }}>
              <SimpleDDL
                isClearable
                id="select_options_month"
                box="search"
                name="month"
                containerclassname="width width-250px"
                placeholder="Bulan"
                menuPosition="fixed"
                options={monthOptions}
                value={this.state.month}
                onChange={(value, { name }) =>
                  this.handleChangeSearchValue(name, value)
                }
              />
              <SimpleDDL
                isClearable
                id="select_options_year"
                box="search"
                name="year"
                containerclassname="width width-250px"
                placeholder="Tahun"
                menuPosition="fixed"
                options={yearOptions}
                value={this.state.year}
                onChange={(value, { name }) =>
                  this.handleChangeSearchValue(name, value)
                }
              />
              <SimpleButton
                styles={{ marginBottom: "15px" }}
                onClick={() => this.handleSearch()}
              >
                Cari
              </SimpleButton>
            </FlexView>
            <FlexView style={{ gap: "50px" }}>
              <SimpleDataTable
                data={this.state.dataTable1}
                columns={this.state.tableConfig}
                options={{
                  serverSide: false,
                  rowsPerPage: 50,
                  rowsPerPageOptions: [],
                }}
              />
              <SimpleDataTable
                data={this.state.dataTable2}
                columns={this.state.tableConfig}
                options={{
                  serverSide: false,
                  rowsPerPage: 50,
                  rowsPerPageOptions: [],
                }}
              />
            </FlexView>
          </>
        );
    };
}

export default MonthToDateSalesReport;